
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.867 2.848v2.941M15.684 2.848v2.941M3.47 9.799h16.61M21.545 19.518c0 .735-.206 1.431-.567 2.02a3.876 3.876 0 01-3.341 1.902 3.808 3.808 0 01-2.57-.98 3.523 3.523 0 01-.772-.922 3.914 3.914 0 013.341-5.942c1.173 0 2.218.52 2.932 1.333a3.93 3.93 0 01.977 2.589z","stroke":"#7367F0","stroke-width":"1.467","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.113 19.518l.968.97 2.08-1.931","stroke":"#7367F0","stroke-width":"1.467","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20.567 9.223v7.707a3.886 3.886 0 00-2.931-1.334 3.914 3.914 0 00-3.342 5.942c.205.353.47.667.772.922h-7.2c-3.42 0-4.886-1.961-4.886-4.903V9.223c0-2.942 1.466-4.903 4.886-4.903h7.816c3.42 0 4.885 1.961 4.885 4.903z","stroke":"#7367F0","stroke-width":"1.467","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.77 14.32h.009M8.153 14.32h.009M8.153 17.262h.009","stroke":"#7367F0","stroke-width":"1.956","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    